<div class="button">
    <ng-content></ng-content>
</div>